export default __webpack_public_path__ + "static/media/KOD0126-min.c4d9ac55.webp";